import { TextInput, Grid } from '@ts/storybook';

interface IIntervalInputProps {
  value: {
    min: number;
    max: number;
  };
  onChange: (value: { min: number; max: number }) => void;
  isReadOnly?: boolean;
}

export const IntervalInput = (props: IIntervalInputProps) => {
  const { value, isReadOnly } = props;
  const { min, max } = value || {};

  const onChangeMin = minValue => {
    const intervalValue = {
      min: minValue,
      max: max,
    };
    props.onChange(intervalValue);
  };

  const onChangeMax = maxValue => {
    const intervalValue = {
      min: min,
      max: maxValue,
    };
    props.onChange(intervalValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <TextInput type="number" label="Minimum" value={min} onChangeValue={onChangeMin} isReadOnly={isReadOnly} />
      </Grid>
      <Grid size={6}>
        <TextInput type="number" label="Maximum" value={max} onChangeValue={onChangeMax} isReadOnly={isReadOnly} />
      </Grid>
    </Grid>
  );
};

export default IntervalInput;
